import { createContext } from "react";
import { Theme } from "../../types/theme";
import { useContext } from "react";
import { Range } from "../../types/range";
import { Controls } from "../../types/controls";

export type RootState = {
  loop: boolean;
  autoplay: boolean;
  aspectRatio: number | undefined;
  controls: Controls;
  startTime?: number;
  theme: Theme;
  poster?: string | undefined;
  label?: string | undefined;
  clipRange?: Range;
  setClipRange?: (range: Range) => void;
  clippingEnabled: boolean;
  setClippingEnabled?: (enable: boolean) => void;
  minimumClipGap: number;
};

export const RootContext = createContext<RootState | undefined>(undefined);

export const useRoot = () => {
  const context = useContext(RootContext);

  if (context === undefined) {
    throw new Error("useRoot must be used within a RootProvider");
  }
  return context;
};
